// This function toggles the value of a specific key in the ProductExtraInfos array
// of a product object. If the key is found and its value is '1' or '0',
export function toggleProductExtraInfoFlag(
  productObject: any,
  key: string
): void {
  if (!productObject?.ProductExtraInfos) return;

  const item = productObject.ProductExtraInfos.find(
    (info: any) => info.key === key
  );

  if (item && (item.value === '1' || item.value === '0')) {
    item.value = item.value === '1' ? '0' : '1';
  }
}
